// Allow-list — anything not in this set is rejected from the backoffice.
// Keep in sync with BACKOFFICE_ALLOWED_ROLES in
// dingoo-api/app/shared/utils/auth.js.
export const BACKOFFICE_ALLOWED_ROLES: ReadonlySet<string> = new Set([
	"sysadmin",
	"admin",
	"manager",
	"supervisor",
	"dispatcher",
	"driver",
	"operator",
	"service-account",
])

export const isBackofficeAllowedRole = (role: unknown): boolean =>
	typeof role === "string" && BACKOFFICE_ALLOWED_ROLES.has(role)
